var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var ApiError = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(ApiError, _Error);

  /**
   * Create new ApiError
   *
   * @param  {object} options {code<One of ApiError.CODES>, message<string>}
   */
  function ApiError(options) {
    var _this;

    _classCallCheck(this, ApiError);

    if (options && options.code && Object.values(ApiError.CODES).indexOf(options.code) > -1) {
      var codeKey = Object.keys(ApiError.CODES).find(function (key) {
        return ApiError.CODES[key] === options.code;
      });
      _this = _possibleConstructorReturn(this, _getPrototypeOf(ApiError).call(this, "".concat(codeKey, ": ").concat(options.message || options.code)));
      _this.code = codeKey;
    } else if (options && options.message) {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(ApiError).call(this, options.message));
    } else {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(ApiError).call(this));
    }

    return _possibleConstructorReturn(_this);
  }

  return ApiError;
}(_wrapNativeSuper(Error));

ApiError.CODES = {
  // CODE: Message
  BAD_TOKEN: 'Unknown app token',
  UNREACHABLE_HTTPS_API: 'Fast api is unreachable with https, try with http',
  UNREACHABLE_HTTP_API: 'Fast api is unreachable, check your network connection',
  UNKNOWN: 'Unknown error'
};
module.exports = ApiError;